import Vue from 'vue';
import VueI18n from 'vue-i18n';
import router from '../router';

Vue.use(VueI18n);

const localeName = getLocaleName();

const loadedLanguages = []; // our default language that is preloaded

function setI18nLanguage(lang) {
  i18n.locale = lang;
  return lang;
}

function getLocaleName() {
  switch (window.locale) {
    case 'en-GB':
      return 'gb';
    default:
      return window.locale;
  }
}

class CustomFormatter {
  constructor(options) {}

  interpolate(message, values) {
    // Функция которая позволяет подменять в переведенной строке специальные символы на строки
    // По умолчанию заменяется символ "%s"
    let str = message;
    if (Array.isArray(values)) {
      values.forEach((val)=>{
        str = str.replace('%s', val);
      });
    }
    return str;
  }
}

export const i18n = new VueI18n({ // import {i18n} from '[some-path]/startup/i18n.js' дает доступ к локализации в любом месте приложения
  locale: localeName, // set locale
  fallbackLocale: localeName,
  formatter: new CustomFormatter(/* here the constructor options */),
  messages: {}, // default emty
});

export function loadLanguageAsync() { // Позволяет загружать локализацию всинхронно
  /* // If the same language
  if (i18n.locale === localeName) { //на случай динамической смены языков без перезагрузки страницы, пускай будет
    return Promise.resolve(setI18nLanguage(localeName));
  }

  // If the language was already loaded
  if (loadedLanguages.includes(localeName)) {
    return Promise.resolve(setI18nLanguage(localeName));
  }*/

  // If the language hasn't been loaded yet
  return import(`../localisation/${window.locale}.json`).then(
      (messages) => {
        i18n.setLocaleMessage(localeName, messages.default);
        loadedLanguages.push(localeName);
        return setI18nLanguage(localeName);
      },
  ).catch(()=>{
    router.replace('/404.com.html');
  });
}
